// BannerCarouselWithCourses.jsx
import React, { useEffect, useRef, useState } from "react";

/** 👇 Import THREE sets of images: mobile, tablet, desktop */
import mob1 from "../assets/homebanner/neet-m.webp";
import mob2 from "../assets/homebanner/jee-m.webp";
import mob3 from "../assets/homebanner/jee-m.webp";

import tab1 from "../assets/homebanner/neet-m.webp";
import tab2 from "../assets/homebanner/jee-m.webp";
import tab3 from "../assets/homebanner/jee-m.webp";

import desk1 from "../assets/homebanner/neet.webp";
import desk2 from "../assets/homebanner/01.webp";
import desk3 from "../assets/homebanner/03.webp";

/** Each slide has sources for mobile/tablet/desktop */
const slides = [
  {
    alt: "Rankridge NEET toppers",
    src: { mobile: mob1, tablet: tab1, desktop: desk1 },
  },
  {
    alt: "IIT-JEE classroom",
    src: { mobile: mob2, tablet: tab2, desktop: desk2 },
  },
  {
    alt: "Campus & labs",
    src: { mobile: mob3, tablet: tab3, desktop: desk3 },
  },
];

const courses = [
  { label: "Intermediate (MPC/BiPC)", href: "/intermediate" },
  { label: "IIT-JEE (Mains + Adv.)", href: "/iit-jee" },
  { label: "NEET (Long-Term)", href: "/neet" },
];

export default function BannerCarouselWithCourses() {
  const [index, setIndex] = useState(0);
  const intervalRef = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    intervalRef.current = window.setInterval(
      () => setIndex((i) => (i + 1) % slides.length),
      5000
    );
    return () => {
      if (intervalRef.current) {
        window.clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  const goTo = (i) =>
    setIndex(((i % slides.length) + slides.length) % slides.length);

  return (
    <header className="relative bg-gradient-to-r from-[#00a6a8] to-emerald-400">
      <section aria-label="Promotional banners" className="relative w-full">
        <div className="absolute inset-0 -z-10 bg-gradient-to-br from-emerald-100 via-teal-100 to-sky-100" />

        {/* Responsive height container */}
        <div
          className="
            relative overflow-hidden
            h-[46vh] min-h-[220px] max-h-[360px]
            sm:h-[50vh] sm:max-h-[420px]
            md:h-[56vh] md:max-h-[560px]
            lg:h-[64vh] lg:max-h-[680px]
          "
        >
          {slides.map((s, i) => (
            <picture
              key={s.alt}
              className={`absolute inset-0 block transition-opacity duration-700 ${
                i === index ? "opacity-100" : "opacity-0"
              }`}
            >
              {/* Desktop first (≥1024px) */}
              <source media="(min-width: 1024px)" srcSet={s.src.desktop} />
              {/* Tablet (≥640px) */}
              <source media="(min-width: 640px)" srcSet={s.src.tablet} />
              {/* Mobile (<640px) */}
              <img
                src={s.src.mobile}
                alt={s.alt}
                className="h-full w-full object-cover"
                loading={i === 0 ? "eager" : "lazy"}
                decoding={i === 0 ? "sync" : "async"}
              />
            </picture>
          ))}

          {/* Dots */}
          <div className="absolute left-1/2 -translate-x-1/2 bottom-3 flex gap-2">
            {slides.map((_, i) => (
              <button
                key={i}
                aria-label={`Go to slide ${i + 1}`}
                onClick={() => goTo(i)}
                className={`h-2.5 w-2.5 rounded-full transition ${
                  i === index ? "bg-white" : "bg-white/60 hover:bg-white/80"
                }`}
              />
            ))}
          </div>
        </div>

        {/* Overlap cards (3 cols even on mobile; scaled down) */}
        <div className="relative -mt-6 sm:-mt-8 md:-mt-10 lg:-mt-12 px-3 sm:px-4 md:px-6">
          <div className="mx-auto w-full max-w-7xl">
            <div className="grid grid-cols-3 gap-2 sm:gap-3 md:gap-4">
              {courses.map((c) => (
                <a
                  key={c.label}
                  href={c.href}
                  className="rounded-2xl bg-white px-2.5 py-2.5 sm:px-4 sm:py-4 md:px-6 md:py-5 ring-1 ring-neutral-200/90 hover:ring-teal-300 shadow-sm hover:shadow-lg transition text-center"
                >
                  <h3 className="text-neutral-900 font-semibold leading-tight text-[11px] sm:text-sm md:text-base">
                    {c.label}
                  </h3>
                  <p className="mt-1 text-[10px] sm:text-xs md:text-sm text-neutral-600">
                    Learn More & Apply
                  </p>
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Spacer only for larger screens */}
      <div className="h-0 sm:h-6 md:h-10 lg:h-12" />
    </header>
  );
}
